/**
 * The number of cities faire has retailers in, rounded to a nice number we're comfortable disclosing for marketing purposes (e.g. shown on the about us page)
 */ export var FAIRE_RETAILERS_NUMBER_OF_CITIES = 'FAIRE_RETAILERS_NUMBER_OF_CITIES';
